import React from 'react';
import { TabList } from '@mui/lab';
import { useStyles } from './style';



const TabListFp = ({ children, ...rest }) => {
  const classes = useStyles();
  return (
    <TabList
      classes={{
        indicator: classes.indicator,
      }}
      {...rest}
    >
      {children}
    </TabList>
  );
};

export default TabListFp;
